import { useClerk, useAuth as useClerkAuth, useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '@/features/auth/stores/auth.store';
import { clientInstance } from '@/shared/lib/graphql-client';

export const useAuth = () => {
  const clerk = useClerk();
  const { user, isLoaded: userLoaded, isSignedIn } = useUser();
  const { getToken } = useClerkAuth();

  const { userProfile, isLoading, setUserProfile, setLoading, clearAuth } = useAuthStore();

  const navigate = useNavigate();

  useEffect(() => {
    const syncAuthToken = async () => {
      if (isSignedIn && user) {
        setUserProfile({
          id: user.id,
          email: user.primaryEmailAddress?.emailAddress || '',
          name: user.fullName || user.firstName || user.username || undefined,
          picture: user.imageUrl,
          nickname: user.username || undefined,
        });

        // Configurer la fonction de refresh token pour le client GraphQL
        clientInstance.setTokenRefreshFunction(async () => {
          try {
            const freshToken = await getToken();
            return freshToken;
          } catch (error) {
            console.error('Failed to refresh token:', error);
            return null;
          }
        });
      } else if (!isSignedIn) {
        clearAuth();
        clientInstance.clearAuthToken();
        // Supprimer la fonction de refresh quand l'utilisateur n'est pas connecté
        clientInstance.setTokenRefreshFunction(() => Promise.resolve(null));
      }
    };

    syncAuthToken();
  }, [isSignedIn, user, setUserProfile, clearAuth, getToken]);

  useEffect(() => {
    setLoading(!userLoaded);
  }, [userLoaded, setLoading]);

  const login = () => {
    navigate('/sign-in');
  };

  const logout = () => {
    clerk.signOut();
  };

  return {
    isAuthenticated: isSignedIn || false,
    isLoading: isLoading || !userLoaded,
    user: userProfile,
    login,
    logout,
  };
};
